import * as action_types from './action_types';
import axios from '../utils/axiosClient';

export const forgetPassword = (data) => {
  const request = axios.get(`member/memberbyemail/${data}`);
  return {
    type: action_types.FORGET_PASSWORD,
    payload: request,
  };
};

export const generatePassword = (data) => {
  const request = axios.get(`member/generatepwd/${data}`);
  return {
    type: action_types.GENERATE_PASSWORD,
    payload: request,
  };
};
